export default {
  loading: 'Cargando...'
}
